



















import {
  defineComponent,
  ref,
  PropType,
  onMounted,
} from '@vue/composition-api';
import { Toast } from '@hb/coffee';
import { UserCreditData } from '@/pages/home/types';
import { PocketMoneyStatusEnum } from '@/api/homeV2Status/types';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { TP_HOME_POCKET_MONEY_CARD } from '@/pages/home/tianqi';

/** 零用钱卡片 */
export default defineComponent({
  name: 'PocketMoneyCard',
  props: {
    userCreditData: {
      type: Object as PropType<UserCreditData>,
      required: true,
    },
  },
  setup(props) {
    /** 零用钱可用额度 */
    const pocketMoneyAvailableAmount = ref(props.userCreditData.pocketMoneyAvailableAmount || '0.00');

    /** 零用钱卡片点击事件 */
    const onPocketMoneyCardClick = () => {
      Toast('零用钱额度已用完，您可申请其他额度');
      ubtSetupPageButton(TP_HOME_POCKET_MONEY_CARD);
    };

    onMounted(() => {
      if (props.userCreditData.pocketMoneyStatus === PocketMoneyStatusEnum.LENT) {
        ubtSetupModuleExpose(TP_HOME_POCKET_MONEY_CARD);
      }
    });

    return {
      pocketMoneyAvailableAmount,
      onPocketMoneyCardClick,
      PocketMoneyStatusEnum,
    };
  },
});
